import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { APIProvider, useApiIsLoaded } from '@vis.gl/react-google-maps';
import { showErrorNotification } from "../../../../swzutils";
import AUTH from "../../../../constants/Auth";
const MapLoaderInner = ({ onMapLoaded }) => {
    const loaded = useApiIsLoaded();
    useEffect(() => {
        if (loaded) {
            onMapLoaded && onMapLoaded();
        }
    }, [loaded]);
    return null;
};
const onApiError = () => showErrorNotification("Failed to load Google Maps.  Please check your internet connection and try again.");
const MapLoader = ({ onMapLoaded }) => (_jsx(APIProvider, { apiKey: AUTH.googleMapsApiKey, libraries: ['places', 'marker'], onError: onApiError, children: _jsx(MapLoaderInner, { onMapLoaded: onMapLoaded }) }));
export default MapLoader;
